import { createSlice } from "@reduxjs/toolkit";
import { downloadReport } from "api/downloadReport";

const initialState = {
    convertedToCSV: '',

}

export const downloadRepo = createSlice({
    name: "downloadRepo",
    initialState,
    reducers: {
        setConvertedToCSV: (state, action) => {
            state.convertedToCSV = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(downloadReport.pending, (state, action) => {
                state.loading = true;
                state.convertedToCSV = "";
            })
            .addCase(downloadReport.fulfilled, (state, action) => {
                state.loading = false;
                state.convertedToCSV = `'${action.payload}'`
            })
            .addCase(downloadReport.rejected, (state, action) => {
                state.loading = false;
            })
    },
});

export const {
    convertedToCSV,
} = downloadRepo.actions;


export default downloadRepo.reducer;    